import React from 'react';
import { Link } from 'react-router-dom';

interface FeatureItem {
  title: string;
  description: string;
  icon: string;
  color: string;
}

const ServicesOverviewSection: React.FC = () => {
  const features: FeatureItem[] = [
    {
      title: "Personalized Practice Tests",
      description: "AI-curated tests that adapt to your learning pace and focus on your weak areas.",
      icon: "fas fa-user-edit",
      color: "#667eea"
    },
    {
      title: "Instant Knowledge Gap Analysis",
      description: "Real-time identification of your learning gaps with detailed performance insights.",
      icon: "fas fa-search-plus",
      color: "#764ba2"
    },
    {
      title: "Voice-Enabled AI Doubt Solver",
      description: "Ask questions naturally and get instant explanations from our AI tutor.",
      icon: "fas fa-microphone-alt",
      color: "#2d9cdb"
    },
    {
      title: "Topic-wise Performance Tracker",
      description: "Monitor your progress across subjects with detailed analytics and trends.",
      icon: "fas fa-chart-bar",
      color: "#f39c12"
    },
    {
      title: "Smart Leaderboard with Peer Comparison",
      description: "Compare your performance with peers and stay motivated with rankings.",
      icon: "fas fa-trophy",
      color: "#27ae60"
    }
  ];

  return (
    <div className="container-fluid wiziai-features py-5">
      <div className="container py-5">
        <div className="section-title position-relative text-center mx-auto mb-5 pb-4 wow fadeInUp"
          data-wow-delay="0.1s" style={{ maxWidth: "800px" }}>
          <h4 className="text-primary mb-3">Powerful Features</h4>
          <h1 className="display-4 mb-4">Why Students Choose <span className="wiziai-gradient-text">WiziAI</span></h1>
          <p className="mb-1 fs-5">
            Experience the future of exam preparation with our AI-powered features designed to accelerate 
            your JEE and NEET success through personalized learning and intelligent insights.
          </p>
        </div>
        <div className="row g-4 justify-content-center">
          {features.map((feature, index) => (
            <div key={index} className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`${0.1 + index * 0.1}s`}>
              <div className="card h-100 border-0 shadow-sm position-relative overflow-hidden" 
                style={{ 
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
                }}>
                <div className="card-body p-4 text-center">
                  <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4"
                    style={{ 
                      width: '80px', 
                      height: '80px',
                      backgroundColor: `${feature.color}15`,
                      border: `2px solid ${feature.color}`
                    }}>
                    <i className={`${feature.icon} fa-2x`} style={{ color: feature.color }}></i>
                  </div>
                  <h5 className="card-title fw-bold mb-3">{feature.title}</h5>
                  <p className="card-text text-muted">{feature.description}</p>
                  <Link to="/features" className="btn btn-outline-primary  mt-3">
                    Learn More <i className="fas fa-arrow-right ms-1"></i>
                  </Link>
                </div>
                {/* <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center text-white opacity-0"
                  style={{ 
                    background: `linear-gradient(135deg, ${feature.color}90, ${feature.color}60)`,
                    transition: 'opacity 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.opacity = '1';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.opacity = '0';
                  }}>
                  <div className="text-center p-4">
                    <i className={`${feature.icon} fa-3x mb-3`}></i>
                    <h6 className="fw-bold">{feature.title}</h6>
                    <p className="small">{feature.description}</p>
                    <Link to="/features" className="btn btn-light btn-sm">
                      Learn More <i className="fas fa-arrow-right ms-1"></i>
                    </Link>
                  </div>
                </div> */}
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-5 wow fadeInUp" data-wow-delay="0.6s">
          <Link to="/signup" className="btn btn-primary btn-lg px-5 py-3">
            Experience All Features - Start Free Trial
            <i className="fas fa-rocket ms-2"></i>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ServicesOverviewSection;
